export default class Direction {
  constructor() {
    this._items = [
      {value: 0, label: 'Приход'},
      {value: 1, label: 'Расход'},
    ];
    this._loading = false;
  }

  get(){
    const self = this;
    return new Promise((resolve, reject) => {
      self.set();
      resolve(self);
    });
  }
  set(data){
    this._items = [
      {value: 0, label: 'Приход'},
      {value: 1, label: 'Расход'},
    ];
  }
  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get items() {
    return this._items;
  }
}